import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  pagination: {
    "& .MuiBox-root": {
      position: "absolute !important",
      right: "270px",
      top: "19%",
    },
    "& .MuiTablePagination-caption:first-of-type": { position: "absolute" },
    "& .MuiTablePagination-selectRoot": {
      position: "absolute",
      left: "130px",
      top: "25.5%",
      "& svg": {
        top: "calc(50% - 14px)",
      },
    },
    "& .MuiBox-root.MuiBox-root-290": { position: "absolute" },
  },
  getMoreBtn: { position: "absolute" },
  tableHead: {
    backgroundColor: "#fafafa",
    tableLayout: "fixed",
    width: "100%",
    fontSize: 13,
  },
  tableHeadContent: {
    fontSize: 13,
    paddingTop: 11,
    paddingBottom: 11,
  },
  emailRow: {
    cursor: "pointer",
    "&:hover": { background: "#eee" },
  },
  nextButton: { marginRight: 10, marginLeft: 5 },
});
